import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * whenever the route changes. This ensures users always start at the top
 * when navigating to a new page.
 * 
 * Enhanced for mobile compatibility with proper timing and multiple scroll methods.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Detect if device is mobile/touch device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || 
                     ('ontouchstart' in window) ||
                     (window.innerWidth < 768)
    
    // Function to scroll to top with multiple methods for maximum compatibility
    const scrollToTop = () => {
      // Method 1: Scroll window (primary method)
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: isMobile ? 'auto' : 'smooth'
      })
      
      // Method 2: Direct scrollTop assignment (works better on mobile)
      if (document.documentElement) {
        document.documentElement.scrollTop = 0
      }
      if (document.body) {
        document.body.scrollTop = 0
      }
    }
    
    // Immediate scroll
    scrollToTop()
    
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      scrollToTop()
    })
    
    // Additional scroll after a brief delay for mobile devices
    // This ensures content is fully rendered before scrolling
    const timeoutId = setTimeout(() => {
      scrollToTop()
    }, isMobile ? 50 : 10)
    
    return () => clearTimeout(timeoutId)
  }, [pathname])

  return null
}

export default ScrollToTop

